import { useTranslation } from "react-i18next";
import KpiGrid from "./KpiGrid";
import LinePlot from "./charts/LinePlot";
import BarPlot from "./charts/BarPlot";
import StackedYesNoPlot from "./charts/StackedBarPlot";

export default function DashboardOverviewSection({
  kpis,
  yesnoByKey,
  yesnoItems,
  tsSurveys,
  tsTemp,
  topSoil,
  topAnimals,
  topWaste,
}) {
  const { t } = useTranslation();

  return (
    <section className="mb-8">
      <div className="mb-3">
        <h2 className="text-lg font-semibold text-slate-900">
          {t("dashboard.overview.title", "Visió general")}
        </h2>
        <p className="text-sm text-slate-600">
          {t(
            "dashboard.overview.subtitle",
            "Indicadors globals i agregacions principals del conjunt de formularis."
          )}
        </p>
      </div>

      <div className="mb-4 min-w-0">
        <KpiGrid kpis={kpis} yesno={yesnoByKey} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <div className="min-w-0">
          <LinePlot
            title={t("dashboard.overview.surveysPerDay", "Enquestes per dia")}
            points={tsSurveys}
            yLabel={t("dashboard.overview.countLabel", "comptatge")}
          />
        </div>

        <div className="min-w-0">
          <LinePlot
            title={t(
              "dashboard.overview.avgSoilTempPerDay",
              "Temperatura mitjana del sòl per dia"
            )}
            points={tsTemp}
            yLabel="°C"
          />
        </div>
      </div>

      <div className="mb-4 min-w-0">
        <StackedYesNoPlot
          title={t("dashboard.overview.yesNoEmptyByBlock", "Sí/No/Buit per bloc")}
          items={yesnoItems}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        <div className="min-w-0">
          <BarPlot
            title={t("dashboard.overview.topSoilTypes", "Top tipologies de sòl")}
            items={topSoil}
          />
        </div>

        <div className="min-w-0">
          <BarPlot
            title={t(
              "dashboard.overview.topAnimalCategories",
              "Top categories d’animals"
            )}
            items={topAnimals}
          />
        </div>

        <div className="min-w-0">
          <BarPlot
            title={t(
              "dashboard.overview.topWasteCategories",
              "Top categories de residus"
            )}
            items={topWaste}
          />
        </div>
      </div>
    </section>
  );
}
